import Renderer from '../MDRenderer/renderer.js'
import React, { useState } from 'react';
import {v4 as uuidv4} from 'uuid';


import './sidebar.css';




export default function Sidebar({viewportWidth, mdWidth, openModal, blocksData, setBlocksData, targetID, updateTargetID}){
    const [editingBlock, setEditingBlock] = useState(false);

    if (targetID === -1) {
        return null
    }

    var button = (
        <button style={{"float": "right"}} onClick={() => setEditingBlock(true)}>Edit Block</button>
    )

    var sidebarContent = (
        <Renderer content = {blocksData['blocks'][targetID]?.content || ""}/>
    )

    const setColor = (e) => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['bg_color'] = e.target.value
        setBlocksData(clone)
    }

    const setTitle = (e) => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['title'] = e.target.value
        setBlocksData(clone)
    }

    const set_x_offset = (e) => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['offset'][0] = e.target.value
        setBlocksData(clone)
    }

    const set_y_offset = (e) => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['offset'][1] = e.target.value
        setBlocksData(clone)
    }

    const set_x_size = (e) => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['size'][0] = e.target.value
        setBlocksData(clone)
    }

    const set_y_size = (e) => {
        const clone = structuredClone(blocksData);
        clone['blocks'][targetID]['size'][1] = e.target.value
        setBlocksData(clone)
    }

    const deleteBlockHelper = (blocks, target) => {
        if (target === "base"){
            alert("You cannot delete the base block")
            return
        }

        for (const childID of (blocks['blocks'][target]['children'] || []) ){
            deleteBlockHelper(blocks, childID)
        }

        // Remove child reference from parent
        const parentID = blocks['blocks'][target]['parent']
        var updatedChildArr = blocks['blocks'][parentID]['children']
        blocks['blocks'][parentID]['children'] = updatedChildArr.filter(e => e !== target)
        if (blocks['blocks'][parentID]['children'].length === 0) {
            delete blocks['blocks'][parentID]['children']
        }

        delete blocks['blocks'][target]
    }

    const deleteBlock = (target) => {
        const clone = structuredClone(blocksData);
        deleteBlockHelper(clone, target);
        updateTargetID(-1)
        setBlocksData(clone)
    }

    const createBlock = () => {
        const clone = structuredClone(blocksData);
        let child_uuid = uuidv4();

        clone['blocks'][child_uuid]  = {
            "parent": targetID,
            "title": "I am a new block!",
            "bg_color": "#FFFFFF",
            "size": [
                40,
                40
            ],
            "offset": [
                30,
                30
            ],
            "content": "Add some content!"  
        }
        if (clone['blocks'][targetID]["children"] !== undefined){
            clone['blocks'][targetID]["children"].push(child_uuid)
        } else {
            clone['blocks'][targetID]["children"] = [child_uuid]  
        }
        setBlocksData(clone)
    }

    if (editingBlock){
        var bg_color = blocksData['blocks'][targetID]['bg_color'] || "white"
        var title = blocksData['blocks'][targetID]['title'] || ""
        var [x_offset, y_offset] = blocksData['blocks'][targetID]['offset'] || [50, 50]
        var [x_size, y_size] = blocksData['blocks'][targetID]['size'] || [50, 50]



        sidebarContent = (
            <>
            <div>
                <label for="head">Background Color: </label>
                <input type="color" id="head" name="head" value={bg_color} onChange={(e) => setColor(e)}/>
            </div>

            <div>
                <label for="title">Title: </label>
                <input type="text" id="title" name="title" value={title} onChange={(e) => setTitle(e)}/>
            </div>

            <div>
                <label for="x_offset">X Offset: </label>
                <input type="range" max="100" min="0" id="x_offset" name="x_offset" value={x_offset} onChange={(e) => set_x_offset(e)}/>
            </div>
            <div>
                <label for="y_offset">Y Offset: </label>
                <input type="range" max="100" min="0" id="y_offset" name="y_offset" value={y_offset} onChange={(e) => set_y_offset(e)}/>
            </div>

            <div>
                <label for="x_size">Width: </label>
                <input type="range" max="100" min="0" id="x_size" name="x_size" value={x_size} onChange={(e) => set_x_size(e)}/>
            </div>
            <div>
                <label for="y_size">Height: </label>
                <input type="range" max="100" min="0" id="y_size" name="y_size" value={y_size} onChange={(e) => set_y_size(e)}/>
            </div>
            <button onClick={() => deleteBlock(targetID)}>Delete Block</button>
            <button onClick={() => createBlock(targetID)}>Add Child</button>

            </>
        )
        button = <button style={{"float": "right"}} onClick={() => setEditingBlock(false)}>View Wiki Content</button>
    }

    return (
        <div className="MdContainer" style={{"marginLeft": viewportWidth, "width": mdWidth-20, "paddingTop": "8px"}}>
            <button onClick={() => updateTargetID(-1)}>Close</button>
            {button}
            <button style={{"float": "right"}} onClick={openModal}>Edit Wiki</button>
            <hr/>
            {sidebarContent}
        </div>
    )
}